<template>
  <g class="wind-speed">
    <g
      v-for="(windSpeed, index) in visualizationWindSpeeds"
      :key="index"
      :transform="`translate(${windSpeed.positionX} -${windSpeed.positionY})`"
    >
      <use
        x="-2"
        y="-2"
        width="4"
        height="4"
        :xlink:href="`#wind-volume${level(windSpeed.windSpeed)}`"
      />
    </g>
  </g>
</template>

<script>
import config from '@/config.js';
  
  export default {
    computed: {
      spots: ({ $store }) => $store.getters['area/spotAll'],
      visualizationWindSpeeds: (vm) => vm.spots.filter((spot) => vm.isOpenSpot(spot)).map((spot) => vm.buildWindSpeedBy(spot)),
      visualizationWindSpeedConfig:() => config.visualizationHeaders['wind_speed'],
      windSpeedMinValue: (vm) => vm.visualizationWindSpeedConfig.minValue,
      windSpeedMaxValue: (vm) => vm.visualizationWindSpeedConfig.maxValue,
      windSpeedColorCount: (vm) => vm.visualizationWindSpeedConfig.colors.length,
      level: (vm) => (value) => vm.calculateWindSpeedLevel(value),
    },
    methods: {
      isOpenSpot(spot) {
        return spot.spotState && spot.type.indexOf('OpenSpot') >= 0;
      },
      calculateWindSpeedLevel(value) {
        if (this.windSpeedMaxValue <= this.windSpeedMinValue || !Number.isFinite(value)) return 1;

        const normalized = Math.max(0, Math.min(1, (value - this.windSpeedMinValue) / (this.windSpeedMaxValue - this.windSpeedMinValue)));
        const level = Math.round(normalized * (this.windSpeedColorCount - 1)) + 1;
        return level;
      },
      buildWindSpeedBy(spot) {
        return {
          positionX: spot.positionX,
          positionY: spot.positionY,
          windSpeed: spot.spotState.windSpeed || 1,
        };
      },
    },
  };
</script>



// WEBPACK FOOTER //
// wind_speed.vue?fdf75f8e